/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { FreelancerCompanyUpdateAddressRequest } from './';
import {
    FreelancerCompanyUpdateAddressRequestFromJSON,
    FreelancerCompanyUpdateAddressRequestFromJSONTyped,
    FreelancerCompanyUpdateAddressRequestToJSON,
} from './';
import type { FreelancerCompanyUpdateLegalNoticesRequest } from './';
import {
    FreelancerCompanyUpdateLegalNoticesRequestFromJSON,
    FreelancerCompanyUpdateLegalNoticesRequestFromJSONTyped,
    FreelancerCompanyUpdateLegalNoticesRequestToJSON,
} from './';
import type { FreelancerCompanyUpdateTaxesRequest } from './';
import {
    FreelancerCompanyUpdateTaxesRequestFromJSON,
    FreelancerCompanyUpdateTaxesRequestFromJSONTyped,
    FreelancerCompanyUpdateTaxesRequestToJSON,
} from './';
import type { FreelancerCompanyUpdateTypeRequest } from './';
import {
    FreelancerCompanyUpdateTypeRequestFromJSON,
    FreelancerCompanyUpdateTypeRequestFromJSONTyped,
    FreelancerCompanyUpdateTypeRequestToJSON,
} from './';
import type { FreelancerCompanyUpdateVatExemptionRequest } from './';
import {
    FreelancerCompanyUpdateVatExemptionRequestFromJSON,
    FreelancerCompanyUpdateVatExemptionRequestFromJSONTyped,
    FreelancerCompanyUpdateVatExemptionRequestToJSON,
} from './';

/**
 * 
 * @export
 * @interface FreelancerCompanyUpdateBusinessDetailsRequest
 */
export interface FreelancerCompanyUpdateBusinessDetailsRequest {
    /**
     * 
     * @type {string}
     * @memberof FreelancerCompanyUpdateBusinessDetailsRequest
     */
    companyName: string;
    /**
     * 
     * @type {string}
     * @memberof FreelancerCompanyUpdateBusinessDetailsRequest
     */
    registrationNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof FreelancerCompanyUpdateBusinessDetailsRequest
     */
    vatNumber?: string;
    /**
     * 
     * @type {FreelancerCompanyUpdateAddressRequest}
     * @memberof FreelancerCompanyUpdateBusinessDetailsRequest
     */
    addressRequest: FreelancerCompanyUpdateAddressRequest;
    /**
     * 
     * @type {FreelancerCompanyUpdateTypeRequest}
     * @memberof FreelancerCompanyUpdateBusinessDetailsRequest
     */
    companyTypeRequest: FreelancerCompanyUpdateTypeRequest;
    /**
     * 
     * @type {FreelancerCompanyUpdateLegalNoticesRequest}
     * @memberof FreelancerCompanyUpdateBusinessDetailsRequest
     */
    legalNoticesRequest: FreelancerCompanyUpdateLegalNoticesRequest;
    /**
     * 
     * @type {FreelancerCompanyUpdateVatExemptionRequest}
     * @memberof FreelancerCompanyUpdateBusinessDetailsRequest
     */
    vatExemptionRequest: FreelancerCompanyUpdateVatExemptionRequest;
    /**
     * 
     * @type {FreelancerCompanyUpdateTaxesRequest}
     * @memberof FreelancerCompanyUpdateBusinessDetailsRequest
     */
    taxesRequest: FreelancerCompanyUpdateTaxesRequest;
}

/**
 * Check if a given object implements the FreelancerCompanyUpdateBusinessDetailsRequest interface.
 */
export function instanceOfFreelancerCompanyUpdateBusinessDetailsRequest(value: object): value is FreelancerCompanyUpdateBusinessDetailsRequest {
    if (!('companyName' in value) || value['companyName'] === undefined) return false;
    if (!('addressRequest' in value) || value['addressRequest'] === undefined) return false;
    if (!('companyTypeRequest' in value) || value['companyTypeRequest'] === undefined) return false;
    if (!('legalNoticesRequest' in value) || value['legalNoticesRequest'] === undefined) return false;
    if (!('vatExemptionRequest' in value) || value['vatExemptionRequest'] === undefined) return false;
    if (!('taxesRequest' in value) || value['taxesRequest'] === undefined) return false;
    return true;
}

export function FreelancerCompanyUpdateBusinessDetailsRequestFromJSON(json: any): FreelancerCompanyUpdateBusinessDetailsRequest {
    return FreelancerCompanyUpdateBusinessDetailsRequestFromJSONTyped(json, false);
}

export function FreelancerCompanyUpdateBusinessDetailsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): FreelancerCompanyUpdateBusinessDetailsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'companyName': json['companyName'],
        'registrationNumber': json['registrationNumber'] == null ? undefined : json['registrationNumber'],
        'vatNumber': json['vatNumber'] == null ? undefined : json['vatNumber'],
        'addressRequest': FreelancerCompanyUpdateAddressRequestFromJSON(json['addressRequest']),
        'companyTypeRequest': FreelancerCompanyUpdateTypeRequestFromJSON(json['companyTypeRequest']),
        'legalNoticesRequest': FreelancerCompanyUpdateLegalNoticesRequestFromJSON(json['legalNoticesRequest']),
        'vatExemptionRequest': FreelancerCompanyUpdateVatExemptionRequestFromJSON(json['vatExemptionRequest']),
        'taxesRequest': FreelancerCompanyUpdateTaxesRequestFromJSON(json['taxesRequest']),
    };
}

export function FreelancerCompanyUpdateBusinessDetailsRequestToJSON(value?: FreelancerCompanyUpdateBusinessDetailsRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'companyName': value['companyName'],
        'registrationNumber': value['registrationNumber'],
        'vatNumber': value['vatNumber'],
        'addressRequest': FreelancerCompanyUpdateAddressRequestToJSON(value['addressRequest']),
        'companyTypeRequest': FreelancerCompanyUpdateTypeRequestToJSON(value['companyTypeRequest']),
        'legalNoticesRequest': FreelancerCompanyUpdateLegalNoticesRequestToJSON(value['legalNoticesRequest']),
        'vatExemptionRequest': FreelancerCompanyUpdateVatExemptionRequestToJSON(value['vatExemptionRequest']),
        'taxesRequest': FreelancerCompanyUpdateTaxesRequestToJSON(value['taxesRequest']),
    };
}

